import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BASE}/api`;

export const api = axios.create({ baseURL: API_ROOT });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("voltix_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const orderNumber = cfg.url?.match(/^\/orders\/(VLTX-[A-Z0-9]+)(?:\/|$)/)?.[1];
  const orderToken = orderNumber && localStorage.getItem(`voltix_order_${orderNumber}`);
  if (orderToken) cfg.headers["X-Order-Token"] = orderToken;
  return cfg;
});
